(ns dre.components.collapse
  (:require
   ["antd" :refer [Collapse]]
   [dre.components.icons-iconoir :refer [icoinor-icon]]
   [dre.i18n.views :refer [tr]]
   [reagent.core :as r]))

(defn icon-fn
  [props]
  (let [props-clj (js->clj props :keywordize-keys true)]
    (if (:isActive props-clj)
      (r/as-element [icoinor-icon :nav-arrow-down])
      (r/as-element [icoinor-icon :nav-arrow-up]))))

(defn collapse
  ([items]
   (collapse items nil))
  ([items active-items]
  (let [items-with-meta (map-indexed (fn [idx itm]
                                       (-> itm (assoc :key idx))) items)]
    [:> Collapse
     {:ghost true
      :items items-with-meta
      :expandIcon icon-fn
      :defaultActiveKey (cond
                          (= active-items :all) (mapv :key items-with-meta)
                          (= active-items :none) []
                          :else [(:key (first items-with-meta))])}])))
